// import axios from 'axios'
import api from '../../api'
import Vue from 'vue'

const state = {
    ingredient_lists: [{title: 'Ingredients', ingredients: []}],
    editing: null
}

const mutations = {
    ADD_INGREDIENT_GROUP (state) {
        state.ingredient_lists.push({title: '', ingredients: []})
    },
    SET_GROUP_TITLE (state, value) {
        Vue.set(state.ingredient_lists[value.index], 'title', value.title)
    },
    ADD_INGREDIENT (state, data) {
        if (!state.ingredient_lists[data.parent]) {
            state.ingredient_lists.push({ingredients: []})
        }
        let ingredient = {parent: data.parent, raw: null, stream: data.stream, position: data.position}
        if(data.value && data.value.raw && data.value.measure && data.value.unit) {
            ingredient = data.value
        }
        ingredient.stream = data.stream
        state.ingredient_lists[data.parent].ingredients.push(ingredient)
        // state.editing = ingredient
        Vue.set(state, 'editing', ingredient)
    },
    SET_INGREDIENT (state, value) {
        if ((value.value.description && value.value.description.length > 0) && (value.value.raw)) {
            value.value.dirty = true
        }
        let result = state.ingredient_lists[value.value.parent].ingredients.filter(ingredient => (ingredient.position === value.value.position && ingredient.stream === value.value.stream))
        result = result && result.length > 0 ? result[0] : null
        let index = state.ingredient_lists[value.value.parent].ingredients.indexOf(result)
        Vue.set(state.ingredient_lists[value.value.parent].ingredients, index, value.value)
        // state.main = value
        state.editing = value.value
    },
    SET_INGREDIENTS (state, value) {
        Vue.set(state, 'ingredient_lists', value)
    },
    SET_EDITING (state, value) {
        if (state.editing && !state.editing.dirty) {
            state.ingredient_lists[state.editing.parent].ingredients.splice(state.ingredient_lists[state.editing.parent].ingredients.indexOf(state.editing), 1)
        }
        state.editing = value
    },
    DELETE_INGREDIENT (state, value) {
        let index = state.ingredient_lists[value.parent].ingredients.indexOf(value)
        if (index < 0) return
        state.ingredient_lists[value.parent].ingredients.splice(index, 1)
        /*
        let ingredients = state.ingredient_lists[value.parent].ingredients.filter(ingredient => {
            return ingredient.position !== value.position && ingredient.stream !== value.stream
        })
        let i = 0
        ingredients.forEach(ingredient => ingredient.position = i++)
        Vue.set(state.ingredient_lists[value.parent], 'ingredients', ingredients)
         */
        // state.ingredient_lists[value.parent].ingredients.splice(state.ingredient_lists[value.parent].ingredients.indexOf(value), 1)
        if (state.editing === value)
            state.editing = null
    }
}

const actions = {
    addIngredientGroup ({commit}) {
        commit('ADD_INGREDIENT_GROUP')
    },
    updateGroupTitle ({commit}, value) {
        commit('SET_GROUP_TITLE', value)
    },
    async addIngredient ({state, commit, getters, rootState}, parent) {
        let stream = 0
        if(rootState.Streams.stream) stream = rootState.Streams.stream.id
        commit('ADD_INGREDIENT', {parent: parent, position: getters['ingredients'](parent).length, stream: stream, shopping_measure: 'gms'})
        //commit('SET_EDITING', state.ingredient_lists[parent].ingredients[state.ingredient_lists[parent].ingredients.length - 1])
    },
    async setIngredient ({commit, rootState, getters, state}, data) {
        commit('SET_INGREDIENT', data)
    },
    async setIngredients ({commit}, data) {
        commit('SET_INGREDIENTS', data)
    },
    addVariation ({commit, getters, rootState}, data) {
        data = Object.assign({}, data)
        data.id = null
        commit('ADD_INGREDIENT', {parent: data.parent, value: data, position: getters['ingredients'](data.parent).length, stream: rootState.Streams.stream.id})
        // commit('SET_EDITING', data)
    },
    async deleteIngredient ({commit}, data) {
        commit('DELETE_INGREDIENT', data)
    },
    async setEditing ({commit, rootState, state}, data) {
        if(data) {
            await axios.get(rootState.Settings.apiUrl + '/ingredient/' + data.raw.pub_key + '/measures')
                .then(function (response) {
                    let measures = []
                    response.data.forEach(measure => {
                        measures.push({id: measure.id, text: measure.name, value: measure})
                        if (parseInt(data.food_measure_id) === parseInt(measure.id) && data.measure.name === measure.name) {
                            data.measure = measure
                        }
                    })

                    data.measures = measures
                })
        }
        commit('SET_EDITING', data)
    },
    reorder ({commit, state, rootState, getters}, data) {

        let ingredients = getters['ingredients'](data.list_index)

        var element = ingredients[data.from];
        ingredients.splice(data.from, 1);
        ingredients.splice(data.to, 0, element);

        var i = 0
        ingredients.forEach(ingredient => {
            //if(ingredient.stream === rootState.Streams.stream.id) {
                ingredient.index = i
            //}
            i++
        })

        axios.post(rootState.Settings.apiUrl + '/ingredients/reorder', {ingredients, list_id: state.ingredient_lists[data.list_index].id})
            .then(function (response) {
                var ingredient_lists = state.ingredient_lists
                ingredient_lists[data.list_index] = response.data
                commit('SET_INGREDIENTS', ingredient_lists)
            })
    },
}

const getters = {
    total: (state, getters, rootState) => (value) => {
        return api.getTotalNutrition(value, rootState.Recipe.servings, state.ingredient_lists, rootState.Streams.stream)
    },
    ingredient_total: state => (value, ingredient) => {
        return api.getTotalIngredientNutrition(value, ingredient)
    },
    ingredients: (state, getters, rootState) => index => {
        let ingredients = []
        if (!state.ingredient_lists[index]) return null

        state.ingredient_lists[index].ingredients.forEach(ingredient => {
            if(!rootState.Streams.stream) return
            if(ingredient.stream > 0 && parseInt(ingredient.stream) !== parseInt(rootState.Streams.stream.id)) return
            if(parseInt(rootState.Streams.stream.id) > 0 && ingredient.stream === 0 && ingredients[ingredient.position]) return
                ingredients[ingredient.position] = ingredient
        })

        ingredients = ingredients.sort((a, b) => a.index - b.index)

        return ingredients
    },
    group: state => index => {
        if (!state.ingredient_lists[index]) return null
        return state.ingredient_lists[index]
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
